import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import styles from "./notes.module.scss";

const EditButton = ({ onClick, className = "" }: { onClick: () => void; className?: string }) => {
  const componentName = "notes";
  return (
    <Button
      type="default"
      className={`${styles[`${componentName}__main-section-copy-button`]} ${className}`}
      onClick={onClick}
      icon={<EditOutlined />}
    >
      Edit
    </Button>
  );
};

export default EditButton;
